import { makeAxiosInstance } from 'mailup-react-helpers'

import { beAccountSettingsApiGetSessionOauth2Token } from 'Api/beAccountSettingsApi'

import { logApiError, logApiTiming } from './logger'

import { APP_CLIENT_ID } from '../config/config'
import { type AxiosInstance } from 'axios'

const refreshToken = async (seckey: string): Promise<string> => {
  const { token } = await beAccountSettingsApiGetSessionOauth2Token({
    seckey,
    client_id: APP_CLIENT_ID,
    force: true,
  })

  return token
}

const apiWrapper: AxiosInstance = makeAxiosInstance({
  refreshToken,
  apiTimeLog: logApiTiming,
  apiErrorLog: logApiError,
})
export default apiWrapper

export const extractApiData = ({ data }: { data: any }): any => data
